import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, CardContent, Fab } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import MDBox from "components/MDBox";
import MDBadge from "components/MDBadge";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import ClearIcon from "@material-ui/icons/Clear";
import { agentReportMoreVert } from "globals/configuration/agentReportMoreVert";
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
} from "features/Navbars/DashboardNavbar/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import SettingsIcon from "@mui/icons-material/Settings";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import {
  useMaterialUIController,
  setTransparentNavbar,
  setDarkMode,
  setActivePage,
  setSearchText,
} from "context";
import MDInput from "components/MDInput";
import { makeStyles } from "@material-ui/core/styles";
import MDTypography from "components/MDTypography";
import CTLNotification from "../CTLNotification";
import AgentDetails from "../CTLAgentDashboard/agentDetails";
import CTLBackButtonAction from "../CTLBackButtonAction";
import { setFormSave } from "context";
import { setCallcenterReportsName } from "context";
import MDButton from "components/MDButton";

const useStyles = makeStyles(() => ({
  noBorder: {
    border: "none",
  },
}));

function CTLAgentNavbar({
  absolute,
  light,
  isMini,
  pageAttributes,
  onSearchTextChange,
  onAdvancedFilter,
  onOpenForm,
  DownloadSelected,
  onPublish,
  onChat,
  onFileExport,
  onFileImport,
  onSendMessage,
  onSync,
  onNMSSelect,
  onMarkasRead,
  onMultipleDelete,
  onAgent,
  onDefaultComparison,
  onNoDefaultComparison,
  onAllList,
  onPrint,
  onFilePreView,
  PriPublish,
  Paste,
  onRefresh,
  onViewAll,
  DownloadData,
  DownloadPdf,
  DownloadBillPdf,
  onUploadFax,
  CollapsibleMenuOpen,
  UpdateTableRecords,
  MultipleUpdate,
  onEnableApiAccess,
  ExitPage,
  LogoutStatus,
  onSendEmail,
  onSendSMS,
  onReportFilter,
}) {
  const [navbarType, setNavbarType] = useState();
  const [showSearch, setShowSearch] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const {
    transparentNavbar,
    fixedNavbar,
    darkMode,
    activePage,
    searchText,
    AgentData,
    agentstatusData,
    agentCallBackData,
  } = controller;

  const classes = useStyles();
  const [settingsMenuAnchor, setSettingsMenuAnchor] = useState(null);

  useEffect(() => {
    const handleMessage = (event) => {
      console.log(" event received:", event);
      if (event?.data?.eventType === "openPopup") {
        if (
          AuthenticationService.allowAgentMenus() &&
          activePage.key !== "agentDashboard"
        ) {
          activePage.key = "agentDashboard";
          activePage.name = "Agent Dashboard";
          activePage.url = "home/app/agent dashboard";
          activePage.description = "";
          setActivePage(dispatch, activePage);
        }
      } else if (event?.data?.eventType === "disconnectCallData") {
        setFormSave(dispatch, true);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [activePage]);

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  useEffect(() => {
    setCallcenterReportsName(dispatch, "");
  }, [activePage]);

  useEffect(() => {
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleSettingsMenuOpen = (event) =>
    setSettingsMenuAnchor(event.currentTarget);
  const handleSettingsMenuClose = () => setSettingsMenuAnchor(null);

  const handleOpenMoreMenu = (event) => setOpenMoreMenu(event.currentTarget);

  function handleTransparentNavbar() {
    setTransparentNavbar(
      dispatch,
      (fixedNavbar && window.scrollY === 0) || !fixedNavbar
    );
  }

  const userProfileMenuClicked = () => {
    (activePage.key = "change-Agent-Profile"),
      (activePage.name = "Change-Agent-Profile"),
      (activePage.description = ""),
      (activePage.url = "home/app/configurations/profile"),
      setActivePage(dispatch, activePage);
    setSearchText(dispatch, "");
  };

  const currentServerAddress = window.location.origin;

  function onEnableApiAccess() {
    setConfirmBox(true);
  }

  function CollapsibleMenuOpen(menuItem) {
    activePage.key = menuItem.widgetId;
    activePage.name = menuItem.dashboardType;
    activePage.url = "home/app";
    activePage.description = menuItem.dashboardName;
    activePage.appId = menuItem.widgetId;
    setActivePage(dispatch, activePage);
  }

  const handleOpenPage = (menuItem) => {
    activePage.key = menuItem.key;
    activePage.name = menuItem.name;
    activePage.url = menuItem.url;
    activePage.description = menuItem.description;
    setActivePage(dispatch, activePage);
  };

  const iconsStyle = ({
    palette: { dark, white, text },
  }) => ({
    color: darkMode ? white.main : text.main,
  });

  const handleSearchText = (event) => {
    setSearchText(dispatch, event.target.value);
    onSearchTextChange(event.target.value);
  };
  const handleOpenCallBack = () => {
    activePage.key = "call.Back";
    activePage.name = "Call Back";
    activePage.url = "home/app/call-back";
    activePage.description = "";
    setActivePage(dispatch, activePage);
  };

  return (
    <>
      <CTLBackButtonAction />
      <AppBar
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={(theme) =>
          navbar(theme, { transparentNavbar, absolute, light, darkMode })
        }
      >
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          {/* ---------- LEFT SECTION: Agent Info ---------- */}
          <MDBox
            color="inherit"
            sx={{
              display: "flex",
              flexDirection: "column",
              flex: 1, // Equal width for layout balance
            }}
          >
            {AuthenticationService.allowAgentMenus() && AgentData ? (
              <MDBox sx={{ p: 1 }}>
                {AgentData.agentInfo && (
                  <MDTypography
                    fontWeight="bold"
                    textTransform="capitalize"
                    variant="h6"
                    color={light ? "white" : "dark"}
                    noWrap
                  >
                    {`Campaign / Queue : ${
                      AgentData.agentInfo?.queueDescription || ""
                    } - ${AgentData.agentInfo?.queueSystemName || ""}`}
                  </MDTypography>
                )}
                {AgentData.dialId && (
                  <MDTypography
                    fontWeight="bold"
                    textTransform="capitalize"
                    variant="h6"
                    color={light ? "white" : "dark"}
                    noWrap
                  >
                    Lead : {`${AgentData.dialId}`}
                  </MDTypography>
                )}
              </MDBox>
            ) : (
              AuthenticationService.allowAgentMenus() && (
                <MDTypography
                  fontWeight="bold"
                  textTransform="capitalize"
                  variant="h6"
                  color={light ? "white" : "dark"}
                  noWrap
                >
                  {activePage.name || "No Active Call"}
                </MDTypography>
              )
            )}
          </MDBox>

          {/* ---------- MIDDLE SECTION: Search Bar ---------- */}
          {activePage.key !== "agentDashboard" && (
            <MDBox
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center", // Center horizontally
              }}
            >
              <Card
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  minWidth: 200,
                  maxWidth: 400,
                  mx: 1,
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: 0,
                    m: 0,
                    width: "100%",
                    "&:last-child": { paddingBottom: 0 },
                  }}
                >
                  <tooltip title="Search">
                    <IconButton sx={{ mt: 0.5 }} disableRipple>
                      <Icon color="info" fontSize="large">
                        search
                      </Icon>
                    </IconButton>
                  </tooltip>

                  <MDInput
                    value={searchText}
                    onChange={handleSearchText}
                    placeholder="Search..."
                    fullWidth
                    InputProps={{
                      classes: { notchedOutline: classes.noBorder },
                      style: {
                        fontSize: "16px",
                        cursor: "pointer",
                        padding: "1px 0",
                      },
                      endAdornment: searchText !== "" && (
                        <tooltip title="Clear">
                          <ClearIcon
                            color="error"
                            fontSize="small"
                            onClick={() => {
                              setSearchText(dispatch, "");
                              onSearchTextChange("");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </tooltip>
                      ),
                    }}
                  />

                  {pageAttributes.enableAdvanceSearch && (
                    <tooltip title="Advance Filter">
                      <IconButton sx={{ mt: 0.5 }} onClick={onAdvancedFilter}>
                        <Icon color="success" fontSize="large">
                          tune
                        </Icon>
                      </IconButton>
                    </tooltip>
                  )}
                </CardContent>
              </Card>
            </MDBox>
          )}

          {/* ---------- RIGHT SECTION: Icons / Actions ---------- */}
          {!isMini && (
            <MDBox
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
                justifyContent: "flex-end",
              }}
            >
              {activePage.key === "agentDashboard" &&
                AuthenticationService.allowAgentMenus() && (
                  <MDBox
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <MDButton
                      sx={{ cursor: "default" }}
                      disableRipple
                      disableFocusRipple
                      variant="outlined"
                      onClick={handleOpenCallBack}
                    >
                      {`Call Back : ${agentCallBackData || "0"}`}
                    </MDButton>
                  </MDBox>
                )}

              {pageAttributes.enableReportFilter && (
                <tooltip title="Filter">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    color="info"
                    onClick={onReportFilter}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>filter_alt_icon</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableSMSButton && (
                <tooltip title="SMS">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onSendSMS}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>message_icon</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableEmailButton && (
                <tooltip title="Email">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onSendEmail}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>email_icon</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableUpdateTableRecords && (
                <tooltip title="Report Column Filter">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={UpdateTableRecords}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>table_rows</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableDownloadButton && (
                <tooltip title="Download-CSV">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={DownloadData}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>file_download</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableChatButton && (
                <tooltip title="Chat">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onChat}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>telegram_icon</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableDownloadPdf && (
                <tooltip title="Download Pdf">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={DownloadPdf}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>picture_as_pdf</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableDownloadBillPdf && (
                <tooltip title="Download Bill PDF">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={DownloadBillPdf}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>receipt_long</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableRefresh && (
                <tooltip title="Refresh">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onRefresh}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>refresh_icon</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableViewAll && (
                <tooltip title="ViewAll">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onViewAll}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>preview_icon</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableSyncButton && (
                <tooltip title="Sync">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onSync}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>sync</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableAddAgentButton && (
                <tooltip title="Add Agent">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onAgent}
                    disableRipple
                  >
                    <PersonAddAlt1Icon sx={iconsStyle}>Agent</PersonAddAlt1Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enablePrintButton && (
                <tooltip title="Print">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onPrint}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>print</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableApiAccess && (
                <tooltip title="Enable Api Access">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={onEnableApiAccess}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>token</Icon>
                  </IconButton>
                </tooltip>
              )}

              {pageAttributes.enableLogout && (
                <tooltip title="log-out">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={LogoutStatus}
                    disableRipple
                  >
                    <Icon sx={iconsStyle}>logout</Icon>
                  </IconButton>
                </tooltip>
              )}

              <Tooltip title="Settings">
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  onClick={handleSettingsMenuOpen}
                >
                  <Icon sx={iconsStyle}>settings</Icon>
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={settingsMenuAnchor}
                open={Boolean(settingsMenuAnchor)}
                onClose={handleSettingsMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem
                  onClick={() => {
                    setDarkMode(dispatch, !darkMode);
                    handleSettingsMenuClose();
                  }}
                >
                  <ListItemIcon sx={{ color: "inherit" }}>
                    {darkMode ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText primary={darkMode ? "Light Mode" : "Dark Mode"} />
                </MenuItem>
              </Menu>

              {pageAttributes.enableExitButton && (
                <tooltip title="Exit Page">
                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    onClick={ExitPage}
                    disableRipple
                  >
                    <Icon color="error">close</Icon>
                  </IconButton>
                </tooltip>
              )}
            </MDBox>
          )}

          {/* ---------- Notifications ---------- */}
          <CTLNotification notify={notify} setNotify={setNotify} />
        </Toolbar>
      </AppBar>
    </>
  );
}

CTLAgentNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

CTLAgentNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default CTLAgentNavbar;
